/* STILE DI MILANO - theme.js. Vanilla, deferred. Everything degrades gracefully without JS. */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- drawers ---------- */
  var lastFocus = null;
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    $$('[data-drawer-open="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var f = $('button, a[href], input', d.querySelector('.drawer__panel'));
    if (f) setTimeout(function () { f.focus(); }, 60);
  }
  function closeDrawers() {
    $$('.drawer.is-open').forEach(function (d) {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
    });
    $$('[data-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-drawer-open]');
    if (o) { e.preventDefault(); openDrawer(o.getAttribute('data-drawer-open')); return; }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawers(); return; }
    var cartLink = e.target.closest('[data-cart-link]');
    if (cartLink && window.SDM && window.SDM.cartType === 'drawer' && $('#cart-drawer') && document.body.className.indexOf('template-cart') === -1) {
      e.preventDefault(); openDrawer('cart-drawer');
    }
    var om = e.target.closest('[data-open-modal]');
    if (om) { var m = document.getElementById(om.getAttribute('data-open-modal')); if (m && m.showModal) m.showModal(); }
    if (e.target.closest('[data-close-modal]')) { var dlg = e.target.closest('dialog'); if (dlg) dlg.close(); }
    if (e.target.tagName === 'DIALOG') e.target.close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawers();
    if (e.key === 'Tab') {
      var open = $('.drawer.is-open .drawer__panel');
      if (!open) return;
      var f = $$('button, a[href], input, summary', open).filter(function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- header shadow + reveal ---------- */
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-stuck', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  } else { $$('.reveal').forEach(function (el) { el.classList.add('is-in'); }); }

  /* ---------- cart ---------- */
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (c) { c.textContent = n; c.setAttribute('data-count', n); });
    $$('[data-cart-count-text]').forEach(function (c) { c.textContent = n; });
  }
  function refreshCart() {
    return fetch(root + '?sections=cart-drawer', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (j) {
      var html = new DOMParser().parseFromString(j['cart-drawer'], 'text/html');
      var inner = $('[data-cart-drawer-inner]', html), cur = $('[data-cart-drawer-inner]');
      if (inner && cur) cur.innerHTML = inner.innerHTML;
      return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); return c; });
    });
  }
  function changeLine(line, qty) {
    return fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: +line, quantity: +qty }) })
      .then(function (r) { return r.json(); });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-items] [data-qty], [data-cart-items] [data-remove]');
    if (!btn) return;
    var lineEl = btn.closest('[data-line]'), input = $('[data-line-qty]', lineEl);
    var line = lineEl.getAttribute('data-line');
    var qty = btn.hasAttribute('data-remove') ? 0 : Math.max(0, (+input.value || 0) + (+btn.getAttribute('data-qty')));
    lineEl.style.opacity = '.5';
    changeLine(line, qty).then(function () { return $('#cart-form') ? location.reload() : refreshCart(); });
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-qty]');
    if (!input) return;
    var line = input.closest('[data-line]').getAttribute('data-line');
    changeLine(line, Math.max(0, +input.value || 0)).then(function () { return $('#cart-form') ? location.reload() : refreshCart(); });
  });

  /* ---------- product page ---------- */
  function initProduct(section) {
    var form = $('[data-product-form]', section), vEl = $('[data-variants]', section);
    if (!form || !vEl) return;
    var variants = JSON.parse(vEl.textContent), idInput = $('[data-variant-id]', form);
    var sectionId = section.getAttribute('data-section-id'), url = section.getAttribute('data-product-url');
    var fieldsets = $$('.opt', form);

    function selected() { return fieldsets.map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; }); }
    function matches(v, sel) { return sel.every(function (val, i) { return val === null || v.options[i] === val; }); }
    function markAvailability() {
      var sel = selected();
      fieldsets.forEach(function (fs, i) {
        $$('input', fs).forEach(function (inp) {
          var test = sel.slice(); test[i] = inp.value;
          var ok = variants.some(function (v) { return matches(v, test) && v.available; });
          var lab = $('label[for="' + inp.id + '"]', fs);
          if (lab) lab.classList.toggle('is-soldout', !ok);
        });
        var lbl = $('[data-selected-label]', fs), c = $('input:checked', fs);
        if (lbl && c) lbl.textContent = c.value;
      });
    }
    function onVariant() {
      var v = variants.find(function (x) { return matches(x, selected()); });
      markAvailability();
      if (!v) { $$('[data-atc],[data-atc-sticky]', section).forEach(function (b) { b.disabled = true; }); return; }
      idInput.value = v.id;
      history.replaceState(null, '', url + '?variant=' + v.id);
      fetch(url + '?variant=' + v.id + '&section_id=' + sectionId).then(function (r) { return r.text(); }).then(function (t) {
        var doc = new DOMParser().parseFromString(t, 'text/html');
        var np = $('[data-price-wrap]', doc), cp = $('[data-price-wrap]', section);
        if (np && cp) cp.innerHTML = np.innerHTML;
        var na = $('[data-atc-label]', doc), ca = $('[data-atc-label]', section);
        if (na && ca) ca.textContent = na.textContent;
        var avail = !!(v.available);
        $$('[data-atc],[data-atc-sticky]', section).forEach(function (b) { b.disabled = !avail; });
      });
      if (v.featured_media && v.featured_media.id) {
        var slide = $('[data-media-id="' + v.featured_media.id + '"]', section);
        if (slide) slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }
    form.addEventListener('change', function (e) { if (e.target.closest('.opt')) onVariant(); });
    markAvailability();

    /* quantity */
    form.addEventListener('click', function (e) {
      var s = e.target.closest('[data-qty-step]');
      if (!s) return;
      var q = $('[data-qty-input]', form);
      q.value = Math.max(1, (+q.value || 1) + (+s.getAttribute('data-qty-step')));
    });

    /* add to cart */
    form.addEventListener('submit', function (e) {
      if (e.submitter && e.submitter.name !== 'add') return;
      e.preventDefault();
      var err = $('[data-form-error]', form), btn = $('[data-atc]', form);
      err.hidden = true; btn.setAttribute('aria-busy', 'true'); btn.disabled = true;
      fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j.description || res.j.message || 'Could not add to cart.');
          if (window.SDM && window.SDM.cartType === 'page') { location.href = window.SDM.cartUrl; return; }
          return refreshCart().then(function () { openDrawer('cart-drawer'); });
        })
        .catch(function (ex) { err.textContent = ex.message; err.hidden = false; })
        .then(function () { btn.removeAttribute('aria-busy'); btn.disabled = false; });
    });

    /* gallery dots (mobile) */
    var track = $('[data-gallery]', section), dots = $('[data-dots]', section);
    if (track && dots) {
      var slides = $$('.gallery__slide', track);
      if (slides.length > 1) {
        slides.forEach(function (s, i) { var d = document.createElement('span'); if (!i) d.className = 'is-on'; dots.appendChild(d); });
        if ('IntersectionObserver' in window) {
          var o2 = new IntersectionObserver(function (en) {
            en.forEach(function (x) { if (x.isIntersecting) { var i = slides.indexOf(x.target); $$('span', dots).forEach(function (d, k) { d.classList.toggle('is-on', k === i); }); } });
          }, { root: track, threshold: .6 });
          slides.forEach(function (s) { o2.observe(s); });
        }
      }
    }

    /* sticky add-to-cart (mobile) */
    var sticky = $('[data-sticky-atc]'), mainBtn = $('[data-atc]', form);
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var out = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', out);
      }).observe(mainBtn);
    }
  }
  $$('[data-product-section]').forEach(initProduct);

  /* ---------- collection filters ---------- */
  var ff = $('[data-filter-form]');
  if (ff) {
    var t;
    ff.addEventListener('change', function () { clearTimeout(t); t = setTimeout(function () { ff.submit(); }, 250); });
  }

  /* ---------- related products ---------- */
  $$('[data-recs]').forEach(function (el) {
    var u = el.getAttribute('data-url');
    if (!u || el.querySelector('.grid')) return;
    fetch(u).then(function (r) { return r.text(); }).then(function (t) {
      var doc = new DOMParser().parseFromString(t, 'text/html'), n = $('[data-recs]', doc);
      if (n && n.innerHTML.trim()) { el.innerHTML = n.innerHTML; $$('.reveal', el).forEach(function (x) { x.classList.add('is-in'); }); }
    }).catch(function () {});
  });
})();
